<template>
  <div class="register-new-container">
    <div class="container">
      <!-- 说明文字 -->
      <p class="description">
        只有您购买的设备才需要在此注册，注册以后可以享受更好的服务：1）从设备直接创建服务请求；2）电话中心工程师快速识别您的身份；3）享受更多的会员权益
      </p>

      <!-- 帮助图片 -->
      <div class="content" v-show="!showDeviceInfo">
        <van-image
          width="67%"
          :src="helpImage"
          fit="contain"
        />
      </div>

      <!-- 序列号输入区域 -->
      <div class="sn-box">
        <van-field
          v-model="snInput"
          placeholder="输入序列号 *P12345678*P12345678"
          class="sn-input"
          maxlength="20"
        />
        <van-button 
          type="primary" 
          size="small" 
          class="seek-btn"
          @click="searchDevice"
        >
          查找
        </van-button>
      </div>

      <!-- 设备信息展示 -->
      <div class="device-info" v-if="showDeviceInfo">
        <div class="device-card">
          <van-image
            width="80%"
            :src="deviceInfo.printerimg"
            fit="contain"
            class="device-image"
          />
          <div class="device-details">
            <div class="detail-item">
              <span class="detail-label">设备名称：</span>
              <span class="detail-value">{{ deviceInfo.erpname }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">商品编码：</span>
              <span class="detail-value">{{ deviceInfo.erpcode }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">商品型号：</span>
              <span class="detail-value">{{ deviceInfo.printermodel }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">序列号：</span>
              <span class="detail-value">{{ deviceInfo.sn }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">出厂日期：</span>
              <span class="detail-value">{{ deviceInfo.scan_date }}</span>
            </div>
          </div>
          <p class="confirm-text">请确认以上信息正确后，点击下一步继续完成注册。</p>
        </div>
      </div>

      <!-- 错误信息 -->
      <div class="error-info" v-if="showError">
        <p class="error-msg">
          您输入的序列号没有找到对应的信息，如果您确认输入的序列号正确，请
          <a 
            href="#" 
            class="feedback-link"
            @click="goToFeedback"
          >
            反馈序列号丢失问题
          </a>
          以便我们补录。感谢您的协助！
        </p>
      </div>

      <!-- 下一步按钮 -->
      <van-button 
        type="primary" 
        size="large" 
        class="btn-next"
        :disabled="!canProceed"
        @click="nextStep"
      >
        下一步
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Dialog } from 'vant'

export default {
  name: 'RegisterNewDevice',
  data() {
    return {
      helpImage: require('../../assets/help.png'),
      snInput: '',
      showDeviceInfo: false,
      showError: false,
      canProceed: false,
      deviceInfo: {
        printerimg: '',
        erpname: '',
        erpcode: '',
        printermodel: '',
        sn: '',
        scan_date: ''
      },
      token: ''
    }
  },
  created() {
    this.token = localStorage['access_token']
    if (!this.token) {
      this.checkToken()
    }
  },
  mounted() {
    document.title = '注册新设备'
  },
  methods: {
    // 检查token
    checkToken() {
      // 这里实现token检查逻辑
      const token = localStorage['access_token']
      if (!token) {
        this.$router.push('/login')
      }
      return token
    },
    
    // 搜索设备
    searchDevice() {
      if (this.snInput.length !== 20) {
        Dialog.alert({
          title: '输入提示',
          message: '序列号为20位字母数字组合，请检查是否输入正确。'
        })
        return
      }

      let that = this
      let getUrl = this.global.BASE_RUL_ABC + "/v1/device/shipmentinfo?appid=wxmini&sn=" + this.snInput
      
      Vue.axios.get(getUrl, {
        headers: {
          "Authorization": this.token
        }
      })
      .then(function (result) {
        console.log('设备信息:', result.data)
        if (result.data.code === "0" && result.data.data && result.data.data.length > 0) {
          that.showDeviceInfo = true
          that.showError = false
          that.canProceed = true
          that.deviceInfo = result.data.data[0]
        } else {
          that.showDeviceInfo = false
          that.showError = true
          that.canProceed = false
        }
      })
      .catch(function (error) {
        console.log(error)
        Toast('网络请求错误，请稍后再试！')
        that.showDeviceInfo = false
        that.showError = false
        that.canProceed = false
      })
    },
    
    // 下一步
    nextStep() {
      if (this.canProceed) {
        this.$router.push({ path:'/register'  })		
      }
    },
    
    // 跳转到反馈页面
    goToFeedback() {
        alert("aaa")
        this.$router.push({ path:'/register/SNFeedback', params:{ sn : this.snInput }  })	
    }
  }
}
</script>

<style scoped>
.register-new-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 80px;
  width: 100%;
  box-sizing: border-box;
}

.container {
  padding: 16px;
  max-width: 100%;
  box-sizing: border-box;
}

.description {
  text-align: left;
  font-size: 14px;
  color: #646566;
  line-height: 1.5;
  margin-bottom: 20px;
  word-break: break-all;
}

.content {
  text-align: center;
  margin-bottom: 20px;
}

.sn-box {
  position: relative;
  background-color: #f1f1f1;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sn-input {
  flex: 1;
  background: transparent;
  padding: 0;
}

.sn-input :deep(.van-field__control) {
  background: transparent;
}

.seek-btn {
  border-radius: 16px;
  flex-shrink: 0;
}

.device-info {
  margin-bottom: 20px;
}

.device-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
  text-align: center;
}

.device-image {
  margin-bottom: 16px;
}

.device-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  text-align: left;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
  max-width: 100%;
  gap: 8px;
}

.detail-label {
  color: #646566;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 80px;
}

.detail-value {
  color: #323233;
  text-align: right;
  flex: 1;
  word-break: break-all;
  overflow-wrap: break-word;
  min-width: 0;
}

.confirm-text {
  font-size: 14px;
  color: #969799;
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

.error-info {
  margin-bottom: 20px;
  text-align: center;
}

.error-msg {
  font-size: 14px;
  color: #d46b08;
  line-height: 1.5;
  word-break: break-all;
}

.feedback-link {
  color: #1989fa;
  text-decoration: none;
}

.feedback-link:active {
  color: #1070c4;
}

.btn-next {
  position: fixed;
  bottom: 20px;
  left: 5%;
  right: 5%;
  width: 90%;
  border-radius: 20px;
  background-color: #323233;
  border-color: #323233;
}

.btn-next:disabled {
  background-color: #c8c9cc;
  border-color: #c8c9cc;
}

/* 响应式设计 */
@media (max-width: 360px) {
  .container {
    padding: 12px;
  }
  
  .device-card {
    padding: 16px;
  }
  
  .detail-item {
    font-size: 13px;
  }
  
  .detail-label {
    min-width: 70px;
  }
}

@media (max-width: 320px) {
  .container {
    padding: 8px;
  }
  
  .device-card {
    padding: 12px;
  }
  
  .detail-item {
    font-size: 12px;
  }
  
  .detail-label {
    min-width: 65px;
  }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
  .feedback-link:hover {
    text-decoration: underline;
  }
  
  .device-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
}
</style>